<template>
    <base-form v-bind="{ ...settings }" >
        <base-password
            :input="input"
            class="gocc__authentication__form__field"
            :settings="{
                label: { class: 'field__label--hide', text: $t('global.password') },
                input: {
                    name: 'password',
                    class: 'gocc__authentication__form__field__input',
                    placeholder: $t('global.password'),
                    browserAutocomplete: 'new-password',
                    fileValidation: 'password',
                    errors: [{
                        type: 'validateStrenghtPassword', warning: $t('error.password')
                    }],
                    isMissing: errors.missing.password,
                    noListener: true
                }
            }"
        />
        <base-password
            :input="input"
            class="gocc__authentication__form__field"
            :settings="{
                label: { class: 'field__label--hide', text: $t('global.confirmPassword') },
                input: {
                    name: 'confirmPassword',
                    class: 'gocc__authentication__form__field__input',
                    placeholder: $t('global.confirmPassword'),
                    browserAutocomplete: 'confirm-password',
                    fileValidation: 'confirmPassword',
                    errors: [{
                        type: 'sameAsPassword', warning: $t('error.confirmPassword')
                    }],
                    validationParameter: payload.password,
                    isMissing: errors.missing.confirmPassword,
                    noListener: true
                }
            }"
        />
        <div class="gocc__authentication__form__field--margin">
            <submission-handler>
                <component
                    :is="button"
                    type="submit"
                    class="gocc__authentication__form__button background--green color--white"
                    v-html="$t('global.confirm')"
                />
            </submission-handler>
        </div>
        <router-link
            to="/authentication/login"
            activeClass="active"
            class="gocc__authentication__form__anchor gocc__authentication__form__back display--block color--green capitalize"
        >
            {{ $t('authentication.back') }}
        </router-link>
    </base-form>
</template>

<script>
// store
import { mapState } from '@/hooks/use-store';

// hooks
import { authenticationStructure } from '@/hooks/use-data';

export default {
    ...authenticationStructure,
    setup ( _, { root: { $router, $route } }) {
        // validação se o utilizador acedeu a página
        // com token. Caso não tenha, é redirecionado
        // para a página de login.
        if ( !$route.query.token || !$route.query.email )
            $router.push({ name: 'login' });

        const payload = mapState({ module: 'storePayload', key: 'payload' });
        const errors = mapState({ module: 'storePayload', key: 'errors' });

        return { payload, errors };
    }
};
</script>